// extracted by mini-css-extract-plugin
export default {"emptyContainer":"NoItems_emptyContainer__5rGpL","top":"NoItems_top__E0lyP","bottom":"NoItems_bottom__vy1RP"};